import React, { createContext, useCallback, useState } from 'react';

export const GeoLocationContext = createContext({
  location: '',
  updateLocation: () => {},
});

export const GeoLocationProvider = ({ children, ssrLocation = '' }) => {
  const [location, setLocation] = useState(ssrLocation);

  const updateLocation = useCallback((value) => {
    let city = '';

    if (typeof value === 'string') city = value.trim();
    else if (value?.city) city = value.city.trim();
    else if (value?.name) city = value.name.trim();

    setLocation(city);
  }, []);

  return <GeoLocationContext.Provider value={{ location, updateLocation }}>{children}</GeoLocationContext.Provider>;
};
